import React from 'react'

function OtherPriceInputFormStyle() {
  return (
    <React.Fragment>
      <style jsx='true'>
      {`
        /* MODAL FORM this is for other price input form */
        .modal-content-container.other-price-input-form {
          margin: 5% auto;
          width: 35%;
        }
        .modal-content-container.other-price-input-form .modal-form-contents {
          height: auto;
          overflow: auto;
        }
        /* MODAL FORM END */

        #other-price-form {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        #other-price-form input {
          font-size: 0.9em;
          font-family: arial;
          padding: 3px;
          text-align: center;
        }

        .button-unit {
          margin-top: 20px;
          display: flex;
          justify-content: flex-end;
          margin-bottom: 10px;
        }
      `}
      </style>
    </React.Fragment>
  )
}

export default OtherPriceInputFormStyle
